export function isAiGeneratedItem(item: any): boolean {
  return item?.aiGenerated === true || item?.isAiGenerated === true;
}

export function hasAiGeneratedSubTasks(items: any[] | null | undefined): boolean {
  return Array.isArray(items) && items.some((item) => isAiGeneratedItem(item));
}

export function hasAiGeneratedMacros(macroGroups: any[] | null | undefined): boolean {
  if (!Array.isArray(macroGroups)) {
    return false;
  }

  return macroGroups.some((group: any) => {
    if (Array.isArray(group?.macroActivities)) {
      return group.macroActivities.some((macro: any) => isAiGeneratedItem(macro));
    }
    return isAiGeneratedItem(group);
  });
}

export function hasAiGeneratedMacrosInForm(macroFormControls: any[] | null | undefined): boolean {
  if (!Array.isArray(macroFormControls)) {
    return false;
  }

  return macroFormControls.some((group: any) => group?.get?.('aiGenerated')?.value === true);
}
